import React from 'react';
import { GridCellProps } from '@progress/kendo-react-all';  
import { formatDate } from '../../../utils';


// Generic Date Cell Component to format kendo grid with date cells
interface DateCellProps {
  field: string; 
}

export const GridFormattedDateCell: React.FC<GridCellProps & DateCellProps> = ({ dataItem, field }) => {
  
  const formattedDate = dataItem?.[field] ? formatDate(dataItem[field]) : '';  
  return <td>{formattedDate}</td>;  
};
